:host {
  display: inline-grid;
}